export { initializeReactRouterInstrumentation } from './initialize';
export { NavigationType, ReactRouterVersion } from './types';
export { FaroRoute, createReactRouterV4Options, createReactRouterV5Options, setReactRouterV4V5SSRDependencies, } from './v4v5';
export { FaroRoutes, createReactRouterV6Options, createReactRouterV6DataOptions, setReactRouterV6SSRDependencies, withFaroRouterInstrumentation, } from './v6';
//# sourceMappingURL=index.js.map